export default __webpack_public_path__ + "static/media/icon.73779bdc.svg";